module.exports = __webpack_public_path__ + "static/media/bg-02.43f3a32d.png";